import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DeductionBreakdownListing} from './Pages'
 
export const DeductionBreakdownListingRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DeductionBreakdownListing} />
    </Fragment>
)